import React from 'react';
import { connect, useSelector } from 'react-redux';
import CreateUpdateContent from '../components/pages/waiting-area/create-update-view/content';

function WaitingAreaFormPage(props) {
  const waitingAreaForm = useSelector((state) => state.waitingAreaReducer.waitingAreaForm);
  const showUpdateWaitingAreaModal = useSelector((state) => state.modalReducer.showUpdateWaitingAreaModal);
  const showViewWaitingAreaModal = useSelector((state) => state.modalReducer.showViewWaitingAreaModal);

  return (
    <div>
      <CreateUpdateContent
        waitingAreaForm={waitingAreaForm}
        waitingArea={props.waitingArea}
        showViewWaitingAreaModal={showViewWaitingAreaModal}
        showUpdateWaitingAreaModal={showUpdateWaitingAreaModal}
        updateOrInsert={props.updateOrInsert}
      />
    </div>
  );
}

export default WaitingAreaFormPage;
